import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from "moment";

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        fontStyle: 'bold',
        height: 40,
        fontStyle: 'bold',
        overflowY: 'scroll',
        justifyContent: 'center',
    },
    refrence: {
      width: '20%',
      textAlign: 'left',
      borderRightColor: borderColor,
      borderRightWidth: 1,
      paddingLeft: 2,
      paddingTop: 15,
      height: 40,
  },
    description: {
        width: '30%',
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingLeft: 2,
        paddingTop: 15,
        height: 40,
    },
    description: {
      width: '30%',
      textAlign: 'left',
      borderRightColor: borderColor,
      borderRightWidth: 1,
      paddingLeft: 1,
      paddingTop: 15,
      height: 40,
    },
    qty: {
        width: '30%',
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingLeft: 1,
        paddingTop: 15,
        height: 40,
    },
    amount: {
      width: '20%',
      paddingLeft: 1,
      paddingTop: 15,
     
  }
  });


const AgentTableRow = (items) => {
    var items1 = (JSON.stringify(items));
    var items2 = JSON.parse(items1);
    var items3 = JSON.parse(items2.items);
   var agentdetails=  items3.agentdetails; 
      const rows =  ( 
          <View style={styles.row} key={1}>
              <Text style={styles.refrence}>{agentdetails.first_name} {agentdetails.last_name}</Text>
              <Text style={styles.description}>{agentdetails.address} {agentdetails.city}</Text>
              <Text style={styles.qty}>{agentdetails.email}</Text>
              <Text style={styles.amount}>{agentdetails.mobile_number}</Text>
          </View>
      )
      return (<Fragment>{rows}</Fragment> )
  };
  export default AgentTableRow